import { create } from "zustand";

import type { ReactNode } from "react";

type HeaderState = {
  title: string;
  buttons: ReactNode | null;
  setTitle: (t: string) => void;
  setButtons: (b: ReactNode | null) => void;
};

export const useHeader = create<HeaderState>((set) => ({
  title: "",
  buttons: null,
  setTitle: (t) => set({ title: t }),
  setButtons: (b) => set({ buttons: b }),
}));
